import React from "react";
import { connect } from "react-redux";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import Select from "react-select";
import { getOwnerContactsAction } from "../../../../actions/UserActions";
import {
  getAppointmentVendorTransactionsAction,
  getAppointmentVendorContingenciesAction,
} from "../../../../actions/VendorTransactionActions";
import {
  getTransactionDataAction,
  createTaskAction,
} from "../../../../actions/TransactionActions";
import {
  getContingencyData,
  toastMessage,
  convertTimeToMinutes,
  convertTZ,
  cryptoTokenDecode,
  getMinutes,
  getUTCdate,
  getMinutesWithUTCTZ,
} from "../../../Common/Common";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRange } from "@material-ui/icons";
import * as code from "../../../../config/Constants";
import * as message from "../../../../config/CommonMessages";
import {
  getBuyerAgentMasterTemplateAction,
  addPathwayToTransactionAction,
  removeTransactionPathwayAction,
  getTransactionPathwaysListAction,
} from "../../../../actions/PathwayActions";
import DeletePrompt from "../../../Common/DeletePrompt";
import { KeyboardArrowDown, Delete, Info } from "@material-ui/icons";
import noRecord from "./../../../../assets/img/no-record.png";
import DataTable from "react-data-table-component";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../../config/Constants";
var CryptoJS = require("crypto-js");

class AddTransactionPathway extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      transactionId: this.props.transactionId,
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      errors: "",
      campaignDaysCnt: 0,
      campaignstyles: [],
      activeCampaignId: "",
      activeCampaign: "Select",
      currentCampian: {},

      pathwayId: "",
      startDate: new Date(),
      taskAnchorDateTime: new Date(),
      time: 540,
      selectedDuration: "60",
      deletePrompt: false,
      deletedPathwayId: "",
      deletedPathwayStartDate: "",
      showLoader: true,
      recordPerPage: code.RECORD_PER_PAGE,
      transactionPathwaysData: [],
      disallowDeletePrompt: false,
      permissionArray: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.removeDatabyId = this.removeDatabyId.bind(this);
  }

  columns = [
    {
      name: "Pathway Name",
      selector: "pathwayName",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Start Date",
      selector: "startDate",
      sortable: true,
      width: "140px",
    },
    {
      name: "Days",
      selector: "days",
      sortable: true,
    },

    {
      name: "",
      selector: "action",
      width: "60px",
      right: true,
      ignoreRowClick: true,
    },
  ];

  componentWillMount() {
    this.getBuyerAgentMasterTemplate();
    this.getTransactionPathwaysList();
    this.getUserPermissions();
  }

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        permissionarray = decryptedData.split(",");
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    if (this.state.userType === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    //console.log("here on form submit");
    if (this.state.pathwayId) {
      this.setState({ errors: "" });
      this.addPathwayToTransaction();
    } else {
      // console.log("this.state.eventStart", this.state.pathwayId);
      // console.log("this.state.eventEnd", this.state.startDate);

      this.setState({ errors: "All fields are required" });
    }
  }

  getBuyerAgentMasterTemplate() {
    //console.log("get list");
    this.props
      .getBuyerAgentMasterTemplateAction()
      .then((res) => {
        let campaignstyles = [];
        //console.log("buyerMasterTemplates", this.props.buyerMasterTemplates);
        if (
          this.props.buyerMasterTemplates !== undefined &&
          this.props.buyerMasterTemplates.length !== 0
        ) {
          let activeCampaign = this.props.buyerMasterTemplates[0];
          this.setState({ showLoader: false });
          for (
            var i = 0, len = this.props.buyerMasterTemplates.length;
            i < len;
            i++
          ) {
            let tempDataObj = this.props.buyerMasterTemplates[i];
            let temData = tempDataObj;
            temData.isBySystem =
              tempDataObj.system !== undefined && tempDataObj.system
                ? true
                : false;
            campaignstyles.push(temData);

            if (!!tempDataObj.default && tempDataObj.system) {
              activeCampaign = tempDataObj;
            }
          }
          //console.log("fetched camps", campaignstyles);
          this.setState(
            {
              campaignstyles: campaignstyles,
              campaignDaysCnt: activeCampaign.campaignDays,
              activeCampaign: activeCampaign.name,
              currentCampian: activeCampaign,
              activeCampaignId: activeCampaign._id,
            }
            // () => {
            //   this.getContingencyOptions();
            // }
          );

          // this.changeCampaign(activeCampaign._id);
        }
      })
      .catch((err) => {});
  }

  handlePathwaySelection(e) {
    // console.log("handlePathwaySelection e", e);
    this.setState({
      pathwayId: e.id,
    });
  }

  handleStartDateChange(date, type) {
    // console.log("handleEventStartChange date", date);
    // console.log("handleEventStartChange type", type);

    let dateStr = moment(date).format("YYYY-MM-DD");
    let timeStr = moment(date).format("HH:mm");

    // console.log("handleEventStartChange dateStr", dateStr);
    // console.log("handleEventStartChange timeStr", timeStr);

    if (type == "time") {
      dateStr = moment(this.state.startDate).format("YYYY-MM-DD");
      // console.log("handleEventStartChange type time");
      // console.log("eventStart", this.state.eventStart);
      // console.log("dateStr", dateStr);
    }

    let finalDate = moment(dateStr + " " + timeStr);
    let timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    let formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // console.log("handleEventStartChange finalDate", finalDate);
    // console.log("handleEventStartChange timeStamp", timeStamp);
    // console.log("handleEventStartChange formatedDate", formatedDate);
    // console.log(
    //   "this.props.transactionData.userTimezone",
    //   this.props.transactionData.userTimezone
    // );

    let stDate = moment
      .tz(
        formatedDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.props.transactionData.userTimezone
      )
      .utc()
      .format();

    //console.log("handleEventStartChange eventDate as eventStart", stDate);
    this.setState({
      startDate: date,
    });
  }

  handleStartTimeChange(date, type) {
    let timeMin = getMinutes(date);
    // console.log("handleEventStartChange date", date);
    // console.log("handleEventStartChange type", type);

    let dateStr = moment(date).format("YYYY-MM-DD");
    let timeStr = moment(date).format("HH:mm");

    // console.log("handleEventStartChange dateStr", dateStr);
    // console.log("handleEventStartChange timeStr", timeStr);

    if (type == "time") {
      dateStr = moment(this.state.startDate).format("YYYY-MM-DD");
      // console.log("handleEventStartChange type time");
      // console.log("eventStart", this.state.eventStart);
      // console.log("dateStr", dateStr);
    }

    let finalDate = moment(dateStr + " " + timeStr);
    let timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    let formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // console.log("handleEventStartChange finalDate", finalDate);
    // console.log("handleEventStartChange timeStamp", timeStamp);
    // console.log("handleEventStartChange formatedDate", formatedDate);
    // console.log(
    //   "this.props.transactionData.userTimezone",
    //   this.props.transactionData.userTimezone
    // );

    let stDate = moment
      .tz(
        formatedDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.props.transactionData.userTimezone
      )
      .utc()
      .format();

    //console.log("handleEventStartChange eventDate as eventStart", stDate);
    this.setState({
      taskAnchorDateTime: date,
      startDate: date,
      // time: timeMin,
    });
  }

  addPathwayToTransaction() {
    // const originalDate = new Date(this.state.startDate);
    // console.log("originalDate-306", originalDate);
    // const momentObj = moment(originalDate);
    // const utcFormattedDate = momentObj.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    // console.log("utcFormattedDate-306", utcFormattedDate);

    const utcFormattedDate = getUTCdate(this.state.startDate);

    // console.log("utcFormattedDate-306", utcFormattedDate);

    // const momentObjutc = moment(utcFormattedDate);
    // const convertedDate = momentObjutc
    //   .tz(this.props.transactionData.userTimezone)
    //   .format("YYYY-MM-DDTHH:mm:ss[Z]");
    // console.log("convertedDate", convertedDate);
    // const timeMin =
    //   convertedDate.split("T")[1].split(":")[0] * 60 +
    //   parseInt(convertedDate.split("T")[1].split(":")[1], 10);

    // const timeMin = getMinutesWithUTCTZ(
    //   this.state.startDate,
    //   this.props.transactionData.userTimezone
    // );

    let timeMin = getMinutes(this.state.startDate);
    // console.log("644-timeMin2", timeMin);
    // console.log("timeMin", timeMin);

    let transactionId = this.state.transactionId;
    let pathwayId = this.state.pathwayId;
    let startDate = utcFormattedDate;
    let startDateTime = utcFormattedDate;
    let time = timeMin;

    let data = {
      transactionId: transactionId,
      pathwayId: pathwayId,
      startDate: startDate,
      startDateTime: startDateTime,
      time: time,
      timeDiff: Number(this.state.selectedDuration),
    };
    // console.log("data", data);
    this.props.addPathwayToTransactionAction(data).then((res) => {
      // console.log("add res", res);
      if (res.status === code.OK) {
        // console.log("addPathwayToTransactionAction res: ", res);
        toastMessage(code.SUCCESS, "Pathway added successfully");
      } else {
        this.setState({ errors: res.data });
      }
      this.getTransactionPathwaysList();
    });
  }

  removeDatabyId() {
    this.setState({
      showLoader: true,
      deletePrompt: false,
    });
    let data = {
      transactionId: this.state.transactionId,
      pathwayId: this.state.deletedPathwayId,
      startDate: this.state.deletedPathwayStartDate,
    };
    //console.log("removeDatabyId data", data);
    this.props.removeTransactionPathwayAction(data).then((res) => {
      this.setState({ showLoader: false, deletePrompt: false });
      this.getTransactionPathwaysList();
    });
  }

  openDeletePrompt(id, pathwayStartDate) {
    let today = new Date();

    // console.log("openDeletePrompt id", id);
    // console.log("openDeletePrompt today", today);
    // console.log(
    //   "openDeletePrompt pathwayStartDate",
    //   new Date(pathwayStartDate)
    // );

    if (new Date(pathwayStartDate) > today) {
      this.setState({
        deletePrompt: true,
        deletedPathwayId: id,
        deletedPathwayStartDate: pathwayStartDate,
      });
    } else {
      this.setState({
        disallowDeletePrompt: true,
      });
    }
  }

  getTransactionPathwaysList() {
    this.props
      .getTransactionPathwaysListAction(this.state.transactionId)
      .then((res) => {
        // console.log(
        //   "this.props.transactionPathwaysData ===>",
        //   this.props.transactionPathwaysData
        // );
        // console.log(
        //   "this.props.transactionPathwaysData",
        //   this.props.transactionPathwaysData
        // );
        this.setState({
          transactionPathwaysData: this.props.transactionPathwaysData || [],
          showLoader: false,
        });
      })
      .catch((err) => {});
  }

  setDuration(e) {
    // console.log("E", e);
    // console.log("setDuration e type", typeof e);
    this.setState({
      selectedDuration: e,
    });
  }

  render() {
    let campaignList = [];
    //console.log(" this.state.campaignstyles", this.state.campaignstyles);

    for (let i = 0, len = this.state.campaignstyles.length; i < len; i++) {
      let camp = this.state.campaignstyles[i];
      if (!camp.isDeleted) {
        let data = {
          label: camp.name,
          id: camp._id,
        };
        campaignList.push(data);
        // if (
        //   this.props.transactionData.transactionType === camp.transactionType
        // ) {
        //   campaignList.push(data);
        // }
      }
    }

    // console.log("campaignList", campaignList);
    // console.log(
    //   "render ===> this.props.transactionPathwaysData",
    //   this.props.transactionPathwaysData
    // );
    let rows = [];
    for (
      var i = 0, len = this.state.transactionPathwaysData.length;
      i < len;
      i++
    ) {
      let pathway = this.state.transactionPathwaysData[i];
      // console.log("transactionPathwaysData i==>", pathway);
      // console.log("transactionPathwaysData i startDate==>", pathway.startDate);
      // console.log(
      //   "transactionPathwaysData i startDate moment ==>",
      //   moment(pathway.startDate).format("MM/DD/YYYY")
      // );
      let data = {
        id: pathway._id,
        pathwayName: pathway.name,
        startDate: moment(pathway.startDate).format("MM/DD/YYYY"),
        days: pathway.campaignDays,

        action: (
          <>
            {this.checkPermission([message.manage_pathway]) ? (
              <div className="action-btns">
                <Button
                  variant="transparent"
                  onClick={() => {
                    this.openDeletePrompt(pathway._id, pathway.startDate);
                  }}
                  disabled={
                    this.props.transStatus === "COMPLETED" ? true : false
                  }
                >
                  <Delete />
                </Button>
              </div>
            ) : (
              ""
            )}
          </>
        ),
      };
      rows.push(data);
      //console.log("rows====>", rows);
    }

    return (
      <div>
        {/* <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
          <Col xs="4">
            <h4 className="title-med mt-0 pt-1">Create Appointment</h4>
          </Col>
        </Row> */}
        <div className="multi-step multi-step-admin">
          <div className="admin-steps admin-content-area">
            <div className="container-custom" style={{ paddingTop: 20 }}>
              {this.checkPermission([message.manage_pathway]) && (
                <Form
                  className="form-sm form-admin"
                  onSubmit={this.handleSubmit}
                >
                  <Row className="mb-3">
                    <Col xs={12} sm={3}>
                      <Form.Label>
                        Pathway
                        <span className="text-danger"> *</span>
                      </Form.Label>
                      <Select
                        name="pathway"
                        label={campaignList.label}
                        options={campaignList}
                        value={campaignList.id}
                        placeholder="Select"
                        isSearchable={true}
                        onChange={(e) => this.handlePathwaySelection(e)}
                        required
                      />
                    </Col>

                    <Col xs={12} sm={3}>
                      <Form.Label>
                        Start Date<span className="text-danger"> *</span>
                      </Form.Label>
                      <Form.Group>
                        <DatePicker
                          minDate={new Date()}
                          //maxDate={new Date(this.state.transactionData.endDate)}
                          //minDate={new Date()}
                          // selected={convertTZ(
                          //   moment(this.state.startDate),
                          //   this.props.transactionData.userTimezone
                          // )}
                          selected={new Date(this.state.startDate)}
                          onChange={(date) =>
                            this.handleStartDateChange(date, "date")
                          }
                          dateFormat="MM-d-yyyy"
                          className="form-control form-control-sm pl-1 date-picker"
                          disabled={this.state.pathwayId === ""}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} sm={2}>
                      <Form.Label>
                        Time<span className="text-danger"> *</span>
                      </Form.Label>
                      <Form.Group>
                        <DatePicker
                          // selected={convertTZ(
                          //   moment(this.state.taskAnchorDateTime),
                          //   this.props.transactionData.userTimezone
                          // )}
                          selected={new Date(this.state.startDate)}
                          onChange={(date) =>
                            this.handleStartTimeChange(date, "time")
                          }
                          showTimeSelect
                          showTimeSelectOnly
                          // minTime={new Date(new Date().setHours(8, 0, 0, 0))}
                          // maxTime={new Date(new Date().setHours(21, 0, 0, 0))}
                          timeIntervals={30}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                          className="form-control form-control-sm pl-1 date-picker"
                          disabled={this.state.pathwayId === ""}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} sm={2}>
                      <Form.Label>
                        Duration<span className="text-danger"> *</span>
                      </Form.Label>
                      <Form.Group>
                        <select
                          className="form-control form-control-sm pl-1 date-picker date-duration"
                          value={this.state.selectedDuration}
                          onChange={(e) => this.setDuration(e.target.value)}
                          disabled={this.state.pathwayId === ""}
                        >
                          <option value={15}>15 minutes</option>
                          <option value={20}>20 minutes</option>
                          <option value={30}>30 minutes</option>
                          <option value={45}>45 minutes</option>
                          <option value={60}>1 hour</option>
                          <option value={120}>2 hours</option>
                          <option value={180}>3 hours</option>
                          <option value={240}>4 hours</option>
                        </select>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* <Row>
                  <Col xs={12} sm={2}>
                    <Form.Label>Date:</Form.Label>
                    <Form.Group>
                      <DatePicker
                        minDate={this.checkTransactionDate(
                          new Date(this.state.transactionData.startDate)
                        )}
                        //maxDate={new Date(this.state.transactionData.endDate)}
                        //minDate={new Date()}
                        selected={convertTZ(
                          moment(this.state.eventStart),
                          this.state.transactionData.userTimezone
                        )}
                        onChange={(date) =>
                          this.handleEventStartChange(date, "date")
                        }
                        dateFormat="MM-d-yyyy"
                        className="form-control form-control-sm pl-1 date-picker"
                        disabled={this.state.transactionId === ""}
                      />
                    </Form.Group>
                  </Col>
                  
                </Row> */}
                  {this.state.errors ? (
                    <Row className="mt-2">
                      <Col xs={12} sm={4}>
                        <div className="text-danger">{this.state.errors}</div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row className="mt-2">
                    <Col xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-blue w-90 font-14 mr-3"
                        //onClick={() => this.createEvent()}
                        disabled={
                          this.props.transStatus === "COMPLETED" ? true : false
                        }
                      >
                        Add Pathway
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
              <div className="dt-content-area">
                <h5 style={{ paddingTop: 30 }}>Artwork Pathways</h5>
                <DataTable
                  columns={this.columns}
                  data={rows}
                  //selectableRows
                  sortIcon={<KeyboardArrowDown className="color-grey-1" />}
                  highlightOnHover={true}
                  className="rdt-requests"
                  noDataComponent={
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No records found</p>
                      </div>
                    </div>
                  }
                  //pagination={true}
                  //paginationServer={true}
                  // paginationTotalRows={ this.props.totalPathways
                  //}
                  //paginationPerPage={this.state.recordPerPage}
                  //onChangePage={(page) => this.changePage(page)}
                  // paginationComponentOptions={{
                  //   noRowsPerPage: true,
                  // }}
                />

                <DeletePrompt
                  deletePrompt={this.state.deletePrompt}
                  itemId={this.state.deletedPathwayId}
                  cancel={() => {
                    this.setState({ deletePrompt: false });
                  }}
                  deleteConfirm={this.removeDatabyId}
                />

                <Modal
                  show={this.state.disallowDeletePrompt}
                  dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                  className="modal-med modal-400 modal-delete"
                  centered
                  backdrop={false}
                >
                  <Modal.Body className="pb-0 text-center">
                    <Info />
                    <p>Pathway can't be deleted.</p>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.setState({ disallowDeletePrompt: false });
                      }}
                    >
                      Ok
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    vendorTransactions: state.reducer.vendorTransactions,
    transactions: state.reducer.transactions,
    transactionData: state.reducer.transactionData,
    vendorContingencies: state.reducer.vendorContingencies,
    buyerMasterTemplates: state.reducer.buyerMasterTemplates,
    transactionPathwaysData: state.reducer.transactionPathwaysData,
  };
};

export default connect(
  mapStateToProps,
  {
    getTransactionDataAction,
    createTaskAction,
    getOwnerContactsAction,
    getAppointmentVendorTransactionsAction,
    getAppointmentVendorContingenciesAction,

    getBuyerAgentMasterTemplateAction,
    addPathwayToTransactionAction,
    removeTransactionPathwayAction,
    getTransactionPathwaysListAction,
  }
)(AddTransactionPathway);
